import { Modal, message } from 'antd';
import React, { Component } from 'react';
import SearchRetrieve from '../../common/SearchRetrieve.new';
import $ from "../../../common/AjaxRequest";
import API_URL from "../../../common/url";
import { param } from 'jquery';

export default class ConfigSupervisor extends Component {
    state = {
        params: {},
        visible: false,
    }

    show = (record) => {
        const { hospitalId, directorUserCompellation, directorEmployeeCode } = record;
        this.setState({
            visible: true,
            params:{
                directorUserName:directorUserCompellation ? `${directorUserCompellation}[${directorEmployeeCode}]`:undefined,
                hospitalId,
            }
        });
    }

    hide = () => {
        this.setState({
            visible: false,
        });
    }

    submit = () => {
        const { params } = this.state;
        const { loadData } = this.props;
        const { userId, hospitalId } = params;
        if (!userId) {
            message.warning('请选择医院主管');
            return;
        }
        const options = {
            method: 'POST',
            url: API_URL.hospital.setHospitalDirector,
            data: {
                userId,
                hospitalId,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.hide();
                loadData();
            },
            errorResult: () => {
                message.error(res.error);
            }
        };
        $.sendRequest(options);
    }

    handleChange = (option) => {
        const { params } = this.state;
        params.userId = option.value;
        params.directorUserName = option.text;
        this.setState({params});
    }


    render() {
        const { visible, params } = this.state;
        const asterisk = <span style={{ color: 'red' }}>*</span>;
        return (
            <Modal
                title='配置医院主管'
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                width="480px"
            >
            <div className="modal-content" style={{ padding: '0 20px' }}>
                <ul className="modal-list">
                    <li className="modal-item">
                        <div className="item-left" >{asterisk}医院主管:</div>
                        <div className="item-right" >
                            <SearchRetrieve
                                keyword="keyword"
                                style={{ width: 180 }}
                                params={{ limit: 20, dimissionStatus: 'WORKING' }}
                                placeholder="输入姓名/工号检索"
                                url={API_URL.team.userlist}
                                value={params.directorUserName}
                                config={{  id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                                onChange={ option => this.handleChange(option) }
                            />
                        </div>
                    </li>
                </ul>
            </div>
            </Modal>
        )
    }
    }



// WEBPACK FOOTER //
// ./src/components/hospital/hospitalInfo/ConfigSupervisor.js